import AdFlag from "./AdFlag";

export default AdFlag;
